import React from "react";
import "./style.scss";
import { withStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  withTheme,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@material-ui/core";
import { compose } from "recompose";
import styles from "./DispatchPickupPopupStyles";
import { postData } from "../../../api/componentAPIs";
import { formatAddress } from '../../modules/Dispatch/utils/utils';
import EditIcon from "@material-ui/icons/Edit";
import SelectPickupTerminal from "./SelectPickupTerminal";
import { RMAXLogger } from "../../../services/LoggerService/RMAXLogger";
import { getSpecialNeeds } from '@dataGrid/components/cellRenderer';
import SpecialNeeds from "./DispatchMap/components/Content/SpecialNeeds"
import Contact from "./DispatchMap/components/Contact";
import { getPriorityPickupIcon } from "../../modules/Dispatch/RouteExecution/utils/pickupIcon";
import MapPopupTooltip from "./DispatchMap/components/MapPopupTooltip";
import StyledToolTip from "../../common/StyledToolTip";
import { getClosingSoonDetails } from "./DispatchMap/utils";
import ClosingSoonBadge from "../../modules/Dispatch/Common/ClosingSoonBadge";
import { getPickupStopWithPickupList } from "./PopupUtil";
import ShowPickupNumbers from "./DispatchMap/components/ShowPickupNumbers";


class DispatchUnassignedPickupPopupInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      terminalAnchorEl: null,
    };
  }

  handleTerminalClick = (event) => {
    RMAXLogger.info("ChangePickupTerminalIconClick", {
      pickupId: this.props.data.pickupId,
    });
    this.setState({ terminalAnchorEl: event.currentTarget });
  };

  handleTerminalClose = () => {
    this.setState({ terminalAnchorEl: null });
  };

  handleTerminalChange = (value) => {
    const {
      data: { data },
    } = this.props;
    this.setState({ terminalAnchorEl: null });
    this.props.glEventHub.emit("DispatchEvents", "ShowLoaderDialog", [
      "Pickup terminal change",
    ]);
    const requestObj = {
      pickupId: data.pickupId,
      terminalCode: this.props.activeTerminal,
      toTerminal: value,
    };
    RMAXLogger.info("ChangePickupTerminal", requestObj);
    postData("UpdatePickupTerminal", requestObj).then((response) => {
      if (response.status >= 200 && response.status < 400) {
        this.props.glEventHub.emit("DispatchEvents", "HideLoaderDialog", []);
        return;
      }
      this.handleError(response.status);
    }, () =>{
      this.handleError();
     });
  };

  handleError = (statusCode) => {
    this.props.glEventHub.emit("DispatchEvents", "HideLoaderDialog", []);
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar(
      "An error occurred while changing the pickup terminal. Please try again later.",
      { variant: "error" }
    );
  }

  getShipperContactDetails = (pickup) => {
    return {
      name: pickup?.shipperContactName ?? "",
      phoneNumber: pickup?.shipperPhoneNumber === "0" ? "" : pickup?.shipperPhoneNumber ?? "",
    };
  };

  render() {
    const {
      classes,
      onButtonClicked,
      hideAction,
      data: { data },
      terminalOptions,
      activeTerminal,
      hideTerminalChange,
      markerComponent,
      specialNeeds,
      terminalOffset,
      closingSoonLimitConfig,
      showPickupHistory = true
    } = this.props;
    const address = formatAddress({
      address: data?.shipperAddress,
      city: data?.shipperCity,
      state: data?.shipperState,
      zip: data?.shipperZip,
    });
    const specialNeedsValues = getSpecialNeeds({data});
    const { closingSoonTextClasses, closingSoonText, closingSoonTime } =
      getClosingSoonDetails({
        isActivePickup: !hideAction,
        closeTime: data.pickupCloseTime,
        terminalOffset,
        closingSoonLimitConfig
      });
    const pickupData = getPickupStopWithPickupList(data);
    const primaryPickupId = (
      pickupData.pickupNumberIdList.find((pickup) => pickup.isPrimary) ||
      pickupData.pickupNumberIdList[0]
    )?.pickupId;

    return (
      <Paper className={`popupBGColor ${classes.popupContainer}`}>
        <Table className={classes.table} padding="none">
          <TableHead className={classes.tableHead}>
            <TableRow className={classes.tableHeadHeight}>
              <TableCell colSpan={2}>
                <div className={`${classes.tableStopHeaderCell} ${classes.headerContainer}`}>
                  <span className={classes.pickupMarker}>
                    {markerComponent}
                    {data.pickupPriority ? (
                      <MapPopupTooltip title={data.pickupPriority}>
                        {getPriorityPickupIcon({ className: classes.pickupPriority })}
                      </MapPopupTooltip>
                    ) : null}
                  </span>

                  <span className={classes.tableHeaderCell}>
                    <MapPopupTooltip title={data.shipperName}>
                      <span className={classes.customerName}>{data.shipperName}</span>
                    </MapPopupTooltip>
                    <div>
                      <MapPopupTooltip title={address}>
                        <div className={classes.address}>{address}</div>
                      </MapPopupTooltip>
                    </div>
                    {hideTerminalChange ? (
                      <div className={classes.TerminalClickClass}>
                        <span className={classes.terminalName}>{activeTerminal}</span>
                      </div>
                    ) : (
                      <div
                        className={classes.TerminalClickClass}
                        onClick={this.handleTerminalClick}>
                        <span className={classes.terminalName}>{activeTerminal}</span>
                        <EditIcon className={classes.editIcon} />
                      </div>
                    )}
                  </span>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <ShowPickupNumbers
              groupId={data.groupId}
              pickupNumberIdList={pickupData.pickupNumberIdList}
              glEventHub={this.props.glEventHub}
              enableBulkEditAndVoid={this.props.enableBulkEditAndVoid}
            />
            <Contact {...this.getShipperContactDetails(data)} />
            <TableRow className={classes.tableRowRoot}>
              <TableCell className={`${classes.labelCell}  tableCellName`}>Spl Needs</TableCell>
              <TableCell
                align="right"
                className={`${classes.dataCell} ${classes.popupDataStyle} tableCellValue`}>
                <SpecialNeeds
                  specialNeeds={specialNeeds}
                  values={specialNeedsValues}
                  stopData={data}
                />
              </TableCell>
            </TableRow>
            <TableRow className={classes.tableRowRoot}>
              <TableCell
                className={`${classes.nameCellPadding} ${classes.labelCell}  tableCellName`}>
                <div className={classes.dualCellLeft}>HU</div>
                <div className={classes.dualCellRight}>Weight</div>
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.dataCell} ${classes.popupDataStyle}  tableCellValue`}>
                <div className={classes.dualCellLeft}>{data.hu}</div>
                <div className={classes.dualCellRight}>
                  {data.weight ? `${data.weight} lbs` : 'N/A'}
                </div>
              </TableCell>
            </TableRow>
            <TableRow className={classes.tableRowRoot}>
              <TableCell className={`${classes.labelCell}  tableCellName`}>Pieces</TableCell>
              <TableCell
                align="right"
                className={`${classes.dataCell} ${classes.popupDataStyle} tableCellValue`}>
                {data.pieces}
              </TableCell>
            </TableRow>
            <TableRow className={classes.tableRowRoot}>
              <TableCell
                className={`${classes.nameCellPadding} ${classes.labelCell} ${classes.lastTableCell} tableCellName`}>
                <div className={classes.dualCellLeft}>Ready</div>
                <div className={classes.dualCellRight}>Close Time</div>
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.dataCell}  ${classes.lastTableCell} tableCellValue`}>
                <div className={classes.dualCellLeft}>{data.pickupReadyTime}</div>
                <StyledToolTip title={closingSoonText ?? ''}>
                  <div className={`${classes.dualCellRight} ${closingSoonTextClasses}`}>
                    {data.pickupCloseTime}
                  </div>
                </StyledToolTip>
              </TableCell>
            </TableRow>
            {showPickupHistory && pickupData.pickupIdList.length === 1 && (
              <TableRow className={classes.tableRowRoot}>
                <TableCell
                  className={`${classes.nameCellPadding} ${classes.labelCell} ${classes.lastTableCell} tableCellName`}>
                  <span
                    className={classes.pickupHistory}
                    onClick={() =>
                      this.props.glEventHub.emit('showPickupDetails', data.pickupId, true)
                    }>
                    Pickup history
                  </span>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.actionContainer}>
          {closingSoonTime !== null && (
            <div className={classes.closingSoonText}>
              <ClosingSoonBadge
                timeToCloseInMins={closingSoonTime}
                closingSoonLimitConfig={closingSoonLimitConfig}
              />
            </div>
          )}
          {hideAction ? null : (
            <Button
              className={`${classes.recommendationButton} ${
                closingSoonText ? classes.recommendationButtonWithClosingText : ''
              }`}
              variant="contained"
              size="small"
              color="primary"
              onClick={() => onButtonClicked(primaryPickupId)}>
              Show Best Drivers
            </Button>
          )}
        </div>
        {this.state.terminalAnchorEl && (
          <SelectPickupTerminal
            terminalAnchor={this.state.terminalAnchorEl}
            closeTerminalMenu={this.handleTerminalClose}
            handleTerminalChange={this.handleTerminalChange}
            activeTerminal={activeTerminal}
            terminalOptions={terminalOptions}
          />
        )}
      </Paper>
    );
  }
}

export default compose(withStyles(styles), withTheme())(DispatchUnassignedPickupPopupInfo);
